// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionRulesMaybe_root__3JrcP","title":"SectionRulesMaybe_title__24alT","rules":"SectionRulesMaybe_rules__kaSQc"};